import { createRouter, createWebHashHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import KnowledgePage from '@/views/KnowledgePage.vue'
import OverseasService from '@/views/OverseasService.vue'
import LawyerPage from '@/views/LawyerPage.vue'
import LawyerDetail from '@/views/LawyerDetail.vue'
import AboutWenSong from '@/views/AboutPage.vue'
import BusinessPage from '@/views/BusinessPage.vue'
import JoinUsPage from '@/views/JoinUsPage.vue'
import JobDetailPage from '@/views/JobDetailPage.vue'
import CooperationPage from '@/views/CooperationPage.vue'

// 共享的律师数据，与LawyerDetail.vue中的数据保持一致
const lawyerData = {
  '1': { name: '张文文', title: '资深律师，深耕法律十余年' },
  '2': { name: '张博德', title: '资深律师，深耕法律十余年' },
  '3': { name: '童雨田', title: '资深律师，深耕法律十余年' },
  '4': { name: '李文龙', title: '资深律师，深耕法律十余年' },
  '5': { name: '童雨田', title: '资深律师，深耕法律十余年' },
  '6': { name: '李文龙', title: '资深律师，深耕法律十余年' }
};

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
    meta: {
      title: '首页'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: AboutWenSong,
    meta: {
      title: '走进闻讼'
    }
  },
  {
    path: '/knowledge',
    name: 'Knowledge',
    component: KnowledgePage,
    meta: {
      title: '闻讼知识库'
    }
  },
  {
    path: '/overseas',
    name: 'OverseasService',
    component: OverseasService,
    meta: {
      title: '海外服务'
    }
  },
  {
    path: '/lawyers',
    name: 'Lawyers',
    component: LawyerPage,
    meta: {
      title: '律师团队'
    }
  },
  {
    path: '/lawyer/:id',
    name: 'LawyerDetail',
    component: LawyerDetail,
    meta: {
      title: '律师详情'
    }
  },
  {
    path: '/business',
    name: 'Business',
    component: BusinessPage,
    meta: {
      title: '业务介绍'
    }
  },
  {
    path: '/join',
    name: 'JoinUs',
    component: JoinUsPage,
    meta: {
      title: '加入闻讼'
    }
  },
  {
    path: '/cooperation',
    name: 'Cooperation',
    component: CooperationPage,
    meta: {
      title: '商务合作'
    }
  },
  {
    path: '/article/:id',
    name: 'ArticleDetail',
    component: () => import('@/views/ArticleDetail.vue'),
    meta: {
      title: '文章详情'
    }
  },
  {
    path: '/job/:id',
    name: 'JobDetail',
    component: JobDetailPage,
    meta: {
      title: '岗位详情'
    }
  },
  // 404页面
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
  // 滚动行为
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置且是前进/后退操作，则使用保存的位置
    if (savedPosition) {
      return savedPosition;
    }
    
    // 如果路由携带了hash（锚点），则滚动到锚点位置
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      };
    }
    
    // 默认滚动到顶部，添加平滑滚动效果
    return {
      top: 0,
      left: 0,
      behavior: 'smooth'
    };
  }
})

// 全局路由守卫，设置页面标题
router.beforeEach((to, from, next) => {
  // 如果是律师详情页，需要动态设置标题
  if (to.name === 'LawyerDetail' && to.params.id) {
    const lawyerId = to.params.id;
    const lawyer = lawyerData[lawyerId];
    if (lawyer) {
      document.title = `${lawyer.name} - 律师详情`;
    } else {
      document.title = '律师详情';
    }
  } 
  // 其他路由使用meta中的标题
  else if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
})

// 路由后置钩子，确保滚动到顶部
router.afterEach(() => {
  // 强制滚动到顶部，解决某些情况下scrollBehavior不生效的问题
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'auto' // 使用'auto'立即滚动，避免与scrollBehavior冲突
  });
});

export default router